import React, { useEffect, useRef } from 'react';
import { getAttributorData } from '../../utils/activityTracking';
import { useSelector } from 'react-redux';


const GoogleOneTap = React.forwardRef(({ onLogin, cid }, ref) => {
  const cidRef = useRef(cid);

  useEffect(() => {
    cidRef.current = cid;
  }, [cid]);

  const getAttributor = () => getAttributorData();

  const prefs = useSelector(state => state.prefs);

  const handleCredentialResponse = async (response) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_USERS_BACKEND_URL}/api/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: response.credential,
          attributor: getAttributor(),
          externalClientId: cidRef.current,
          prefs,
        }),
      });
      const data = await res.json();
      if (data) {
        onLogin(data);
      }
    } catch (error) {
      console.error("Google login failed", error);
    }
  };

  const initializeOneTap = () => {
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
      auto_select: true,
    });
    window.google.accounts.id.prompt();
  };

  useEffect(() => {
    console.log("Google One Tap component mounted with cid:", cid);
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = initializeOneTap;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Expose handler for tests
  React.useImperativeHandle(ref, () => ({
    handleCredentialResponse,
    initializeOneTap,
  }));

  return <></>;
});

export default GoogleOneTap;
